import React from 'react';
import { Grid } from 'semantic-ui-react';

const CalcColumn = ({ index, column, data, option }) => {

    const convertValue =(value, tag) => { // data, r.name
        if(value === 1){
            if(tag.includes('PCS_BROWNOUT')) return 'BROWNOUT';
            else if (tag.includes('PCS_GRIDOK')) return 'OK';
            else if(tag.includes('PCS_TDGRIDNOTOK')) return 'NOT OK';
            else if(tag.includes('PCS_POWERFOLDBACK')) return 'FOLDBACK';
            else if(tag.includes('OPERIN_EXTERNALPOWER')) return 'EXTERNAL';
            else if(tag.includes('PCS_MCBGRID') || tag.includes('PCS_MCBINV') || tag.includes('PCS_MCBLOAD')) return 'CLOSE';
            else return 'ON';
        }
        else{
            if(tag.includes('PCS_BROWNOUT')) return 'NORMAL';
            else if (tag.includes('PCS_GRIDOK')) return 'NOT OK';
            else if(tag.includes('PCS_TDGRIDNOTOK')) return 'OK';
            else if(tag.includes('PCS_POWERFOLDBACK')) return 'NORMAL';
            else if(tag.includes('OPERIN_EXTERNALPOWER')) return 'LOCAL';
            else if(tag.includes('PCS_MCBGRID') || tag.includes('PCS_MCBINV') || tag.includes('PCS_MCBLOAD')) return 'OPEN';
            else return 'OFF';
        }
    }

       return (
        <Grid.Column key={index} style={{ maxWidth: '600px', padding: '0' }}>
            <Grid columns='equal' style={styles.grid}>
                {column.map(r =>
                    option === 2?
                        r.tag_display_subgroup === "CALCULATIONS" || r.name.slice(4,11) === "PCS_FSW"?
                            ''
                            :
                            // r.name.slice(0,4) === 'DOUT' || r.name.slice(0,3) === 'DIN' || r.name.slice(0,4) === 'PCS_' ||
                            // r.name.slice(0,4) === 'OPER' || r.name.slice(-6) === 'BREAKER' ?
                            r.name.slice(5,9) === 'DOUT' || r.name.slice(5,8) === 'DIN' || r.name.slice(5,9) === 'PCS_' ||
                            r.name.slice(5,9) === 'OPER' || r.name.slice(-6) === 'BREAKER' ?
                                <Grid.Row key={r.id} style={styles.row}>
                                    <Grid.Column width='8' style={styles.name}>{r.tag_display_name}</Grid.Column>
                                    {r.name === 'PCS_GRIDOK' ?
                                        <Grid.Column
                                            style={{color: data[r.id] === 0 ? 'red' : 'white'}}>{convertValue(data[r.id], r.name)}</Grid.Column>
                                        :
                                        <Grid.Column
                                            style={{color: data[r.id] === 1 ? 'red' : 'white'}}>{convertValue(data[r.id], r.name)}</Grid.Column>
                                    }
                                </Grid.Row>
                                :
                                <Grid.Row key={r.id} style={styles.row}>
                                    <Grid.Column width='8' style={styles.name}>{r.tag_display_name}</Grid.Column>
                                    <Grid.Column>{data[r.id]}</Grid.Column>
                                    <Grid.Column>{r.unit}</Grid.Column>
                                </Grid.Row>
                    :
                        <Grid.Row key={r.id} style={styles.row}>
                            <Grid.Column width={8} style={styles.name}>{r.tag_display_name}</Grid.Column>
                            <Grid.Column width={5}>{data[r.id]}</Grid.Column>
                            <Grid.Column width={2}>{r.unit}</Grid.Column>
                        </Grid.Row>

                )}
            </Grid>
        </Grid.Column>
    );
};

const styles = {
    grid: {
        margin: '0'
    },
    row: {
        padding: '2px 0'
    },
    name: {
        color: 'yellow',
        marginLeft: '5px',
        whiteSpace: 'pre-wrap',
        overflowWrap: 'break-word'
    }
};

export default React.memo(CalcColumn);